
import clsx from "clsx";

interface IconProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  icon?: any;
  color?: string;
  size?: number;
}
export default function Icon({
  icon,  
  className,
  label,
  color,
  size=5,
  ...rest
}: IconProps) {
  const Icon = icon;
  return (
    <div
      {...rest}   
      className={className}
    >
      <span className="sr-only">{label}</span>
      <Icon className={clsx(`w-${size}`,className)} color={color} />
    </div>
  );
}
